/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AuthenticatedRouteImport } from './routes/_authenticated'
import { Route as IndexRouteImport } from './routes/index'
import { Route as InviteTokenRouteImport } from './routes/invite/$token'
import { Route as AuthenticatedOnboardingRouteImport } from './routes/_authenticated/onboarding'
import { Route as AuthenticatedDashboardRouteImport } from './routes/_authenticated/dashboard'
import { Route as AuthenticatedCreateOrganizationRouteImport } from './routes/_authenticated/create-organization'
import { Route as OrgOrgIdIndexRouteImport } from './routes/org/$orgId/index'
import { Route as AuthenticatedSettingsIndexRouteImport } from './routes/_authenticated/settings/index'
import { Route as AuthenticatedSettingsApiTokensRouteImport } from './routes/_authenticated/settings/api-tokens'
import { Route as AuthenticatedSettingsAccountRouteImport } from './routes/_authenticated/settings/account'
import { Route as AuthenticatedOrgEnvironmentsRouteImport } from './routes/_authenticated/org/environments'
import { Route as AuthenticatedOrgOrgIdRouteImport } from './routes/_authenticated/org/$orgId'
import { Route as AuthenticatedDashboardBillingRouteImport } from './routes/_authenticated/dashboard/billing'
import { Route as AuthenticatedOrgOrgIdIndexRouteImport } from './routes/_authenticated/org/$orgId/index'
import { Route as AuthenticatedOrgOrgIdWebhooksRouteImport } from './routes/_authenticated/org/$orgId/webhooks'
import { Route as AuthenticatedOrgOrgIdTestProjectRouteImport } from './routes/_authenticated/org/$orgId/test-project'
import { Route as AuthenticatedOrgOrgIdSettingsRouteImport } from './routes/_authenticated/org/$orgId/settings'
import { Route as AuthenticatedOrgOrgIdSecretsRouteImport } from './routes/_authenticated/org/$orgId/secrets'
import { Route as AuthenticatedOrgOrgIdPlansRouteImport } from './routes/_authenticated/org/$orgId/plans'
import { Route as AuthenticatedOrgOrgIdIntegrationsRouteImport } from './routes/_authenticated/org/$orgId/integrations'
import { Route as AuthenticatedOrgOrgIdEnvironmentsRouteImport } from './routes/_authenticated/org/$orgId/environments'
import { Route as AuthenticatedOrgOrgIdBackupsRouteImport } from './routes/_authenticated/org/$orgId/backups'
import { Route as AuthenticatedOrgOrgIdAuditRouteImport } from './routes/_authenticated/org/$orgId/audit'
import { Route as AuthenticatedOrgOrgIdAlertsRouteImport } from './routes/_authenticated/org/$orgId/alerts'
import { Route as AuthenticatedOrgOrgIdAccessRouteImport } from './routes/_authenticated/org/$orgId/access'
import { Route as AuthenticatedOrgOrgIdProjectsIndexRouteImport } from './routes/_authenticated/org/$orgId/projects/index'
import { Route as AuthenticatedOrgOrgIdProjectsIdIndexRouteImport } from './routes/_authenticated/org/$orgId/projects/$id/index'
import { Route as AuthenticatedOrgOrgIdProjectsIdSettingsRouteImport } from './routes/_authenticated/org/$orgId/projects/$id/settings'
import { Route as AuthenticatedOrgOrgIdProjectsIdSecretsRouteImport } from './routes/_authenticated/org/$orgId/projects/$id/secrets'
import { Route as AuthenticatedOrgOrgIdProjectsIdRuntimeConfigRouteImport } from './routes/_authenticated/org/$orgId/projects/$id/runtime-config'
import { Route as AuthenticatedOrgOrgIdProjectsIdEnvironmentsRouteImport } from './routes/_authenticated/org/$orgId/projects/$id/environments'

const AuthenticatedRoute = AuthenticatedRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const InviteTokenRoute = InviteTokenRouteImport.update({
  id: '/invite/$token',
  path: '/invite/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedOnboardingRoute = AuthenticatedOnboardingRouteImport.update({
  id: '/onboarding',
  path: '/onboarding',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedDashboardRoute = AuthenticatedDashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedCreateOrganizationRoute =
  AuthenticatedCreateOrganizationRouteImport.update({
    id: '/create-organization',
    path: '/create-organization',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const OrgOrgIdIndexRoute = OrgOrgIdIndexRouteImport.update({
  id: '/org/$orgId/',
  path: '/org/$orgId/',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedSettingsIndexRoute =
  AuthenticatedSettingsIndexRouteImport.update({
    id: '/settings/',
    path: '/settings/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedSettingsApiTokensRoute =
  AuthenticatedSettingsApiTokensRouteImport.update({
    id: '/settings/api-tokens',
    path: '/settings/api-tokens',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedSettingsAccountRoute =
  AuthenticatedSettingsAccountRouteImport.update({
    id: '/settings/account',
    path: '/settings/account',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedOrgEnvironmentsRoute =
  AuthenticatedOrgEnvironmentsRouteImport.update({
    id: '/org/environments',
    path: '/org/environments',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedOrgOrgIdRoute = AuthenticatedOrgOrgIdRouteImport.update({
  id: '/org/$orgId',
  path: '/org/$orgId',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedDashboardBillingRoute =
  AuthenticatedDashboardBillingRouteImport.update({
    id: '/billing',
    path: '/billing',
    getParentRoute: () => AuthenticatedDashboardRoute,
  } as any)
const AuthenticatedOrgOrgIdIndexRoute =
  AuthenticatedOrgOrgIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedOrgOrgIdRoute,
  } as any)
const AuthenticatedOrgOrgIdWebhooksRoute =
  AuthenticatedOrgOrgIdWebhooksRouteImport.update({
    id: '/webhooks',
    path: '/webhooks',
    getParentRoute: () => AuthenticatedOrgOrgIdRoute,
  } as any)
const AuthenticatedOrgOrgIdTestProjectRoute =
  AuthenticatedOrgOrgIdTestProjectRouteImport.update({
    id: '/test-project',
    path: '/test-project',
    getParentRoute: () => AuthenticatedOrgOrgIdRoute,
  } as any)
const AuthenticatedOrgOrgIdSettingsRoute =
  AuthenticatedOrgOrgIdSettingsRouteImport.update({
    id: '/settings',
    path: '/settings',
    getParentRoute: () => AuthenticatedOrgOrgIdRoute,
  } as any)
const AuthenticatedOrgOrgIdSecretsRoute =
  AuthenticatedOrgOrgIdSecretsRouteImport.update({
    id: '/secrets',
    path: '/secrets',
    getParentRoute: () => AuthenticatedOrgOrgIdRoute,
  } as any)
const AuthenticatedOrgOrgIdPlansRoute =
  AuthenticatedOrgOrgIdPlansRouteImport.update({
    id: '/plans',
    path: '/plans',
    getParentRoute: () => AuthenticatedOrgOrgIdRoute,
  } as any)
const AuthenticatedOrgOrgIdIntegrationsRoute =
  AuthenticatedOrgOrgIdIntegrationsRouteImport.update({
    id: '/integrations',
    path: '/integrations',
    getParentRoute: () => AuthenticatedOrgOrgIdRoute,
  } as any)
const AuthenticatedOrgOrgIdEnvironmentsRoute =
  AuthenticatedOrgOrgIdEnvironmentsRouteImport.update({
    id: '/environments',
    path: '/environments',
    getParentRoute: () => AuthenticatedOrgOrgIdRoute,
  } as any)
const AuthenticatedOrgOrgIdBackupsRoute =
  AuthenticatedOrgOrgIdBackupsRouteImport.update({
    id: '/backups',
    path: '/backups',
    getParentRoute: () => AuthenticatedOrgOrgIdRoute,
  } as any)
const AuthenticatedOrgOrgIdAuditRoute =
  AuthenticatedOrgOrgIdAuditRouteImport.update({
    id: '/audit',
    path: '/audit',
    getParentRoute: () => AuthenticatedOrgOrgIdRoute,
  } as any)
const AuthenticatedOrgOrgIdAlertsRoute =
  AuthenticatedOrgOrgIdAlertsRouteImport.update({
    id: '/alerts',
    path: '/alerts',
    getParentRoute: () => AuthenticatedOrgOrgIdRoute,
  } as any)
const AuthenticatedOrgOrgIdAccessRoute =
  AuthenticatedOrgOrgIdAccessRouteImport.update({
    id: '/access',
    path: '/access',
    getParentRoute: () => AuthenticatedOrgOrgIdRoute,
  } as any)
const AuthenticatedOrgOrgIdProjectsIndexRoute =
  AuthenticatedOrgOrgIdProjectsIndexRouteImport.update({
    id: '/projects/',
    path: '/projects/',
    getParentRoute: () => AuthenticatedOrgOrgIdRoute,
  } as any)
const AuthenticatedOrgOrgIdProjectsIdIndexRoute =
  AuthenticatedOrgOrgIdProjectsIdIndexRouteImport.update({
    id: '/projects/$id/',
    path: '/projects/$id/',
    getParentRoute: () => AuthenticatedOrgOrgIdRoute,
  } as any)
const AuthenticatedOrgOrgIdProjectsIdSettingsRoute =
  AuthenticatedOrgOrgIdProjectsIdSettingsRouteImport.update({
    id: '/projects/$id/settings',
    path: '/projects/$id/settings',
    getParentRoute: () => AuthenticatedOrgOrgIdRoute,
  } as any)
const AuthenticatedOrgOrgIdProjectsIdSecretsRoute =
  AuthenticatedOrgOrgIdProjectsIdSecretsRouteImport.update({
    id: '/projects/$id/secrets',
    path: '/projects/$id/secrets',
    getParentRoute: () => AuthenticatedOrgOrgIdRoute,
  } as any)
const AuthenticatedOrgOrgIdProjectsIdRuntimeConfigRoute =
  AuthenticatedOrgOrgIdProjectsIdRuntimeConfigRouteImport.update({
    id: '/projects/$id/runtime-config',
    path: '/projects/$id/runtime-config',
    getParentRoute: () => AuthenticatedOrgOrgIdRoute,
  } as any)
const AuthenticatedOrgOrgIdProjectsIdEnvironmentsRoute =
  AuthenticatedOrgOrgIdProjectsIdEnvironmentsRouteImport.update({
    id: '/projects/$id/environments',
    path: '/projects/$id/environments',
    getParentRoute: () => AuthenticatedOrgOrgIdRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/create-organization': typeof AuthenticatedCreateOrganizationRoute
  '/dashboard': typeof AuthenticatedDashboardRouteWithChildren
  '/onboarding': typeof AuthenticatedOnboardingRoute
  '/invite/$token': typeof InviteTokenRoute
  '/dashboard/billing': typeof AuthenticatedDashboardBillingRoute
  '/org/$orgId': typeof OrgOrgIdIndexRoute
  '/org/environments': typeof AuthenticatedOrgEnvironmentsRoute
  '/settings/account': typeof AuthenticatedSettingsAccountRoute
  '/settings/api-tokens': typeof AuthenticatedSettingsApiTokensRoute
  '/settings': typeof AuthenticatedSettingsIndexRoute
  '/org/$orgId/access': typeof AuthenticatedOrgOrgIdAccessRoute
  '/org/$orgId/alerts': typeof AuthenticatedOrgOrgIdAlertsRoute
  '/org/$orgId/audit': typeof AuthenticatedOrgOrgIdAuditRoute
  '/org/$orgId/backups': typeof AuthenticatedOrgOrgIdBackupsRoute
  '/org/$orgId/environments': typeof AuthenticatedOrgOrgIdEnvironmentsRoute
  '/org/$orgId/integrations': typeof AuthenticatedOrgOrgIdIntegrationsRoute
  '/org/$orgId/plans': typeof AuthenticatedOrgOrgIdPlansRoute
  '/org/$orgId/secrets': typeof AuthenticatedOrgOrgIdSecretsRoute
  '/org/$orgId/settings': typeof AuthenticatedOrgOrgIdSettingsRoute
  '/org/$orgId/test-project': typeof AuthenticatedOrgOrgIdTestProjectRoute
  '/org/$orgId/webhooks': typeof AuthenticatedOrgOrgIdWebhooksRoute
  '/org/$orgId/': typeof AuthenticatedOrgOrgIdIndexRoute
  '/org/$orgId/projects': typeof AuthenticatedOrgOrgIdProjectsIndexRoute
  '/org/$orgId/projects/$id/environments': typeof AuthenticatedOrgOrgIdProjectsIdEnvironmentsRoute
  '/org/$orgId/projects/$id/runtime-config': typeof AuthenticatedOrgOrgIdProjectsIdRuntimeConfigRoute
  '/org/$orgId/projects/$id/secrets': typeof AuthenticatedOrgOrgIdProjectsIdSecretsRoute
  '/org/$orgId/projects/$id/settings': typeof AuthenticatedOrgOrgIdProjectsIdSettingsRoute
  '/org/$orgId/projects/$id': typeof AuthenticatedOrgOrgIdProjectsIdIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/create-organization': typeof AuthenticatedCreateOrganizationRoute
  '/dashboard': typeof AuthenticatedDashboardRouteWithChildren
  '/onboarding': typeof AuthenticatedOnboardingRoute
  '/invite/$token': typeof InviteTokenRoute
  '/dashboard/billing': typeof AuthenticatedDashboardBillingRoute
  '/org/environments': typeof AuthenticatedOrgEnvironmentsRoute
  '/settings/account': typeof AuthenticatedSettingsAccountRoute
  '/settings/api-tokens': typeof AuthenticatedSettingsApiTokensRoute
  '/settings': typeof AuthenticatedSettingsIndexRoute
  '/org/$orgId': typeof AuthenticatedOrgOrgIdIndexRoute
  '/org/$orgId/access': typeof AuthenticatedOrgOrgIdAccessRoute
  '/org/$orgId/alerts': typeof AuthenticatedOrgOrgIdAlertsRoute
  '/org/$orgId/audit': typeof AuthenticatedOrgOrgIdAuditRoute
  '/org/$orgId/backups': typeof AuthenticatedOrgOrgIdBackupsRoute
  '/org/$orgId/environments': typeof AuthenticatedOrgOrgIdEnvironmentsRoute
  '/org/$orgId/integrations': typeof AuthenticatedOrgOrgIdIntegrationsRoute
  '/org/$orgId/plans': typeof AuthenticatedOrgOrgIdPlansRoute
  '/org/$orgId/secrets': typeof AuthenticatedOrgOrgIdSecretsRoute
  '/org/$orgId/settings': typeof AuthenticatedOrgOrgIdSettingsRoute
  '/org/$orgId/test-project': typeof AuthenticatedOrgOrgIdTestProjectRoute
  '/org/$orgId/webhooks': typeof AuthenticatedOrgOrgIdWebhooksRoute
  '/org/$orgId/projects': typeof AuthenticatedOrgOrgIdProjectsIndexRoute
  '/org/$orgId/projects/$id/environments': typeof AuthenticatedOrgOrgIdProjectsIdEnvironmentsRoute
  '/org/$orgId/projects/$id/runtime-config': typeof AuthenticatedOrgOrgIdProjectsIdRuntimeConfigRoute
  '/org/$orgId/projects/$id/secrets': typeof AuthenticatedOrgOrgIdProjectsIdSecretsRoute
  '/org/$orgId/projects/$id/settings': typeof AuthenticatedOrgOrgIdProjectsIdSettingsRoute
  '/org/$orgId/projects/$id': typeof AuthenticatedOrgOrgIdProjectsIdIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_authenticated': typeof AuthenticatedRouteWithChildren
  '/_authenticated/create-organization': typeof AuthenticatedCreateOrganizationRoute
  '/_authenticated/dashboard': typeof AuthenticatedDashboardRouteWithChildren
  '/_authenticated/onboarding': typeof AuthenticatedOnboardingRoute
  '/invite/$token': typeof InviteTokenRoute
  '/_authenticated/dashboard/billing': typeof AuthenticatedDashboardBillingRoute
  '/_authenticated/org/$orgId': typeof AuthenticatedOrgOrgIdRouteWithChildren
  '/_authenticated/org/environments': typeof AuthenticatedOrgEnvironmentsRoute
  '/_authenticated/settings/account': typeof AuthenticatedSettingsAccountRoute
  '/_authenticated/settings/api-tokens': typeof AuthenticatedSettingsApiTokensRoute
  '/_authenticated/settings/': typeof AuthenticatedSettingsIndexRoute
  '/org/$orgId/': typeof OrgOrgIdIndexRoute
  '/_authenticated/org/$orgId/access': typeof AuthenticatedOrgOrgIdAccessRoute
  '/_authenticated/org/$orgId/alerts': typeof AuthenticatedOrgOrgIdAlertsRoute
  '/_authenticated/org/$orgId/audit': typeof AuthenticatedOrgOrgIdAuditRoute
  '/_authenticated/org/$orgId/backups': typeof AuthenticatedOrgOrgIdBackupsRoute
  '/_authenticated/org/$orgId/environments': typeof AuthenticatedOrgOrgIdEnvironmentsRoute
  '/_authenticated/org/$orgId/integrations': typeof AuthenticatedOrgOrgIdIntegrationsRoute
  '/_authenticated/org/$orgId/plans': typeof AuthenticatedOrgOrgIdPlansRoute
  '/_authenticated/org/$orgId/secrets': typeof AuthenticatedOrgOrgIdSecretsRoute
  '/_authenticated/org/$orgId/settings': typeof AuthenticatedOrgOrgIdSettingsRoute
  '/_authenticated/org/$orgId/test-project': typeof AuthenticatedOrgOrgIdTestProjectRoute
  '/_authenticated/org/$orgId/webhooks': typeof AuthenticatedOrgOrgIdWebhooksRoute
  '/_authenticated/org/$orgId/': typeof AuthenticatedOrgOrgIdIndexRoute
  '/_authenticated/org/$orgId/projects/': typeof AuthenticatedOrgOrgIdProjectsIndexRoute
  '/_authenticated/org/$orgId/projects/$id/environments': typeof AuthenticatedOrgOrgIdProjectsIdEnvironmentsRoute
  '/_authenticated/org/$orgId/projects/$id/runtime-config': typeof AuthenticatedOrgOrgIdProjectsIdRuntimeConfigRoute
  '/_authenticated/org/$orgId/projects/$id/secrets': typeof AuthenticatedOrgOrgIdProjectsIdSecretsRoute
  '/_authenticated/org/$orgId/projects/$id/settings': typeof AuthenticatedOrgOrgIdProjectsIdSettingsRoute
  '/_authenticated/org/$orgId/projects/$id/': typeof AuthenticatedOrgOrgIdProjectsIdIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/create-organization'
    | '/dashboard'
    | '/onboarding'
    | '/invite/$token'
    | '/dashboard/billing'
    | '/org/$orgId'
    | '/org/environments'
    | '/settings/account'
    | '/settings/api-tokens'
    | '/settings'
    | '/org/$orgId/access'
    | '/org/$orgId/alerts'
    | '/org/$orgId/audit'
    | '/org/$orgId/backups'
    | '/org/$orgId/environments'
    | '/org/$orgId/integrations'
    | '/org/$orgId/plans'
    | '/org/$orgId/secrets'
    | '/org/$orgId/settings'
    | '/org/$orgId/test-project'
    | '/org/$orgId/webhooks'
    | '/org/$orgId/'
    | '/org/$orgId/projects'
    | '/org/$orgId/projects/$id/environments'
    | '/org/$orgId/projects/$id/runtime-config'
    | '/org/$orgId/projects/$id/secrets'
    | '/org/$orgId/projects/$id/settings'
    | '/org/$orgId/projects/$id'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/create-organization'
    | '/dashboard'
    | '/onboarding'
    | '/invite/$token'
    | '/dashboard/billing'
    | '/org/environments'
    | '/settings/account'
    | '/settings/api-tokens'
    | '/settings'
    | '/org/$orgId'
    | '/org/$orgId/access'
    | '/org/$orgId/alerts'
    | '/org/$orgId/audit'
    | '/org/$orgId/backups'
    | '/org/$orgId/environments'
    | '/org/$orgId/integrations'
    | '/org/$orgId/plans'
    | '/org/$orgId/secrets'
    | '/org/$orgId/settings'
    | '/org/$orgId/test-project'
    | '/org/$orgId/webhooks'
    | '/org/$orgId/projects'
    | '/org/$orgId/projects/$id/environments'
    | '/org/$orgId/projects/$id/runtime-config'
    | '/org/$orgId/projects/$id/secrets'
    | '/org/$orgId/projects/$id/settings'
    | '/org/$orgId/projects/$id'
  id:
    | '__root__'
    | '/'
    | '/_authenticated'
    | '/_authenticated/create-organization'
    | '/_authenticated/dashboard'
    | '/_authenticated/onboarding'
    | '/invite/$token'
    | '/_authenticated/dashboard/billing'
    | '/_authenticated/org/$orgId'
    | '/_authenticated/org/environments'
    | '/_authenticated/settings/account'
    | '/_authenticated/settings/api-tokens'
    | '/_authenticated/settings/'
    | '/org/$orgId/'
    | '/_authenticated/org/$orgId/access'
    | '/_authenticated/org/$orgId/alerts'
    | '/_authenticated/org/$orgId/audit'
    | '/_authenticated/org/$orgId/backups'
    | '/_authenticated/org/$orgId/environments'
    | '/_authenticated/org/$orgId/integrations'
    | '/_authenticated/org/$orgId/plans'
    | '/_authenticated/org/$orgId/secrets'
    | '/_authenticated/org/$orgId/settings'
    | '/_authenticated/org/$orgId/test-project'
    | '/_authenticated/org/$orgId/webhooks'
    | '/_authenticated/org/$orgId/'
    | '/_authenticated/org/$orgId/projects/'
    | '/_authenticated/org/$orgId/projects/$id/environments'
    | '/_authenticated/org/$orgId/projects/$id/runtime-config'
    | '/_authenticated/org/$orgId/projects/$id/secrets'
    | '/_authenticated/org/$orgId/projects/$id/settings'
    | '/_authenticated/org/$orgId/projects/$id/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuthenticatedRoute: typeof AuthenticatedRouteWithChildren
  InviteTokenRoute: typeof InviteTokenRoute
  OrgOrgIdIndexRoute: typeof OrgOrgIdIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AuthenticatedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/invite/$token': {
      id: '/invite/$token'
      path: '/invite/$token'
      fullPath: '/invite/$token'
      preLoaderRoute: typeof InviteTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/onboarding': {
      id: '/_authenticated/onboarding'
      path: '/onboarding'
      fullPath: '/onboarding'
      preLoaderRoute: typeof AuthenticatedOnboardingRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/dashboard': {
      id: '/_authenticated/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof AuthenticatedDashboardRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/create-organization': {
      id: '/_authenticated/create-organization'
      path: '/create-organization'
      fullPath: '/create-organization'
      preLoaderRoute: typeof AuthenticatedCreateOrganizationRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/org/$orgId/': {
      id: '/org/$orgId/'
      path: '/org/$orgId'
      fullPath: '/org/$orgId'
      preLoaderRoute: typeof OrgOrgIdIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/settings/': {
      id: '/_authenticated/settings/'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AuthenticatedSettingsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/settings/api-tokens': {
      id: '/_authenticated/settings/api-tokens'
      path: '/settings/api-tokens'
      fullPath: '/settings/api-tokens'
      preLoaderRoute: typeof AuthenticatedSettingsApiTokensRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/settings/account': {
      id: '/_authenticated/settings/account'
      path: '/settings/account'
      fullPath: '/settings/account'
      preLoaderRoute: typeof AuthenticatedSettingsAccountRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/org/environments': {
      id: '/_authenticated/org/environments'
      path: '/org/environments'
      fullPath: '/org/environments'
      preLoaderRoute: typeof AuthenticatedOrgEnvironmentsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/org/$orgId': {
      id: '/_authenticated/org/$orgId'
      path: '/org/$orgId'
      fullPath: '/org/$orgId'
      preLoaderRoute: typeof AuthenticatedOrgOrgIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/dashboard/billing': {
      id: '/_authenticated/dashboard/billing'
      path: '/billing'
      fullPath: '/dashboard/billing'
      preLoaderRoute: typeof AuthenticatedDashboardBillingRouteImport
      parentRoute: typeof AuthenticatedDashboardRoute
    }
    '/_authenticated/org/$orgId/': {
      id: '/_authenticated/org/$orgId/'
      path: '/'
      fullPath: '/org/$orgId/'
      preLoaderRoute: typeof AuthenticatedOrgOrgIdIndexRouteImport
      parentRoute: typeof AuthenticatedOrgOrgIdRoute
    }
    '/_authenticated/org/$orgId/webhooks': {
      id: '/_authenticated/org/$orgId/webhooks'
      path: '/webhooks'
      fullPath: '/org/$orgId/webhooks'
      preLoaderRoute: typeof AuthenticatedOrgOrgIdWebhooksRouteImport
      parentRoute: typeof AuthenticatedOrgOrgIdRoute
    }
    '/_authenticated/org/$orgId/test-project': {
      id: '/_authenticated/org/$orgId/test-project'
      path: '/test-project'
      fullPath: '/org/$orgId/test-project'
      preLoaderRoute: typeof AuthenticatedOrgOrgIdTestProjectRouteImport
      parentRoute: typeof AuthenticatedOrgOrgIdRoute
    }
    '/_authenticated/org/$orgId/settings': {
      id: '/_authenticated/org/$orgId/settings'
      path: '/settings'
      fullPath: '/org/$orgId/settings'
      preLoaderRoute: typeof AuthenticatedOrgOrgIdSettingsRouteImport
      parentRoute: typeof AuthenticatedOrgOrgIdRoute
    }
    '/_authenticated/org/$orgId/secrets': {
      id: '/_authenticated/org/$orgId/secrets'
      path: '/secrets'
      fullPath: '/org/$orgId/secrets'
      preLoaderRoute: typeof AuthenticatedOrgOrgIdSecretsRouteImport
      parentRoute: typeof AuthenticatedOrgOrgIdRoute
    }
    '/_authenticated/org/$orgId/plans': {
      id: '/_authenticated/org/$orgId/plans'
      path: '/plans'
      fullPath: '/org/$orgId/plans'
      preLoaderRoute: typeof AuthenticatedOrgOrgIdPlansRouteImport
      parentRoute: typeof AuthenticatedOrgOrgIdRoute
    }
    '/_authenticated/org/$orgId/integrations': {
      id: '/_authenticated/org/$orgId/integrations'
      path: '/integrations'
      fullPath: '/org/$orgId/integrations'
      preLoaderRoute: typeof AuthenticatedOrgOrgIdIntegrationsRouteImport
      parentRoute: typeof AuthenticatedOrgOrgIdRoute
    }
    '/_authenticated/org/$orgId/environments': {
      id: '/_authenticated/org/$orgId/environments'
      path: '/environments'
      fullPath: '/org/$orgId/environments'
      preLoaderRoute: typeof AuthenticatedOrgOrgIdEnvironmentsRouteImport
      parentRoute: typeof AuthenticatedOrgOrgIdRoute
    }
    '/_authenticated/org/$orgId/backups': {
      id: '/_authenticated/org/$orgId/backups'
      path: '/backups'
      fullPath: '/org/$orgId/backups'
      preLoaderRoute: typeof AuthenticatedOrgOrgIdBackupsRouteImport
      parentRoute: typeof AuthenticatedOrgOrgIdRoute
    }
    '/_authenticated/org/$orgId/audit': {
      id: '/_authenticated/org/$orgId/audit'
      path: '/audit'
      fullPath: '/org/$orgId/audit'
      preLoaderRoute: typeof AuthenticatedOrgOrgIdAuditRouteImport
      parentRoute: typeof AuthenticatedOrgOrgIdRoute
    }
    '/_authenticated/org/$orgId/alerts': {
      id: '/_authenticated/org/$orgId/alerts'
      path: '/alerts'
      fullPath: '/org/$orgId/alerts'
      preLoaderRoute: typeof AuthenticatedOrgOrgIdAlertsRouteImport
      parentRoute: typeof AuthenticatedOrgOrgIdRoute
    }
    '/_authenticated/org/$orgId/access': {
      id: '/_authenticated/org/$orgId/access'
      path: '/access'
      fullPath: '/org/$orgId/access'
      preLoaderRoute: typeof AuthenticatedOrgOrgIdAccessRouteImport
      parentRoute: typeof AuthenticatedOrgOrgIdRoute
    }
    '/_authenticated/org/$orgId/projects/': {
      id: '/_authenticated/org/$orgId/projects/'
      path: '/projects'
      fullPath: '/org/$orgId/projects'
      preLoaderRoute: typeof AuthenticatedOrgOrgIdProjectsIndexRouteImport
      parentRoute: typeof AuthenticatedOrgOrgIdRoute
    }
    '/_authenticated/org/$orgId/projects/$id/': {
      id: '/_authenticated/org/$orgId/projects/$id/'
      path: '/projects/$id'
      fullPath: '/org/$orgId/projects/$id'
      preLoaderRoute: typeof AuthenticatedOrgOrgIdProjectsIdIndexRouteImport
      parentRoute: typeof AuthenticatedOrgOrgIdRoute
    }
    '/_authenticated/org/$orgId/projects/$id/settings': {
      id: '/_authenticated/org/$orgId/projects/$id/settings'
      path: '/projects/$id/settings'
      fullPath: '/org/$orgId/projects/$id/settings'
      preLoaderRoute: typeof AuthenticatedOrgOrgIdProjectsIdSettingsRouteImport
      parentRoute: typeof AuthenticatedOrgOrgIdRoute
    }
    '/_authenticated/org/$orgId/projects/$id/secrets': {
      id: '/_authenticated/org/$orgId/projects/$id/secrets'
      path: '/projects/$id/secrets'
      fullPath: '/org/$orgId/projects/$id/secrets'
      preLoaderRoute: typeof AuthenticatedOrgOrgIdProjectsIdSecretsRouteImport
      parentRoute: typeof AuthenticatedOrgOrgIdRoute
    }
    '/_authenticated/org/$orgId/projects/$id/runtime-config': {
      id: '/_authenticated/org/$orgId/projects/$id/runtime-config'
      path: '/projects/$id/runtime-config'
      fullPath: '/org/$orgId/projects/$id/runtime-config'
      preLoaderRoute: typeof AuthenticatedOrgOrgIdProjectsIdRuntimeConfigRouteImport
      parentRoute: typeof AuthenticatedOrgOrgIdRoute
    }
    '/_authenticated/org/$orgId/projects/$id/environments': {
      id: '/_authenticated/org/$orgId/projects/$id/environments'
      path: '/projects/$id/environments'
      fullPath: '/org/$orgId/projects/$id/environments'
      preLoaderRoute: typeof AuthenticatedOrgOrgIdProjectsIdEnvironmentsRouteImport
      parentRoute: typeof AuthenticatedOrgOrgIdRoute
    }
  }
}

interface AuthenticatedDashboardRouteChildren {
  AuthenticatedDashboardBillingRoute: typeof AuthenticatedDashboardBillingRoute
}

const AuthenticatedDashboardRouteChildren: AuthenticatedDashboardRouteChildren =
  {
    AuthenticatedDashboardBillingRoute: AuthenticatedDashboardBillingRoute,
  }

const AuthenticatedDashboardRouteWithChildren =
  AuthenticatedDashboardRoute._addFileChildren(
    AuthenticatedDashboardRouteChildren,
  )

interface AuthenticatedOrgOrgIdRouteChildren {
  AuthenticatedOrgOrgIdAccessRoute: typeof AuthenticatedOrgOrgIdAccessRoute
  AuthenticatedOrgOrgIdAlertsRoute: typeof AuthenticatedOrgOrgIdAlertsRoute
  AuthenticatedOrgOrgIdAuditRoute: typeof AuthenticatedOrgOrgIdAuditRoute
  AuthenticatedOrgOrgIdBackupsRoute: typeof AuthenticatedOrgOrgIdBackupsRoute
  AuthenticatedOrgOrgIdEnvironmentsRoute: typeof AuthenticatedOrgOrgIdEnvironmentsRoute
  AuthenticatedOrgOrgIdIntegrationsRoute: typeof AuthenticatedOrgOrgIdIntegrationsRoute
  AuthenticatedOrgOrgIdPlansRoute: typeof AuthenticatedOrgOrgIdPlansRoute
  AuthenticatedOrgOrgIdSecretsRoute: typeof AuthenticatedOrgOrgIdSecretsRoute
  AuthenticatedOrgOrgIdSettingsRoute: typeof AuthenticatedOrgOrgIdSettingsRoute
  AuthenticatedOrgOrgIdTestProjectRoute: typeof AuthenticatedOrgOrgIdTestProjectRoute
  AuthenticatedOrgOrgIdWebhooksRoute: typeof AuthenticatedOrgOrgIdWebhooksRoute
  AuthenticatedOrgOrgIdIndexRoute: typeof AuthenticatedOrgOrgIdIndexRoute
  AuthenticatedOrgOrgIdProjectsIndexRoute: typeof AuthenticatedOrgOrgIdProjectsIndexRoute
  AuthenticatedOrgOrgIdProjectsIdEnvironmentsRoute: typeof AuthenticatedOrgOrgIdProjectsIdEnvironmentsRoute
  AuthenticatedOrgOrgIdProjectsIdRuntimeConfigRoute: typeof AuthenticatedOrgOrgIdProjectsIdRuntimeConfigRoute
  AuthenticatedOrgOrgIdProjectsIdSecretsRoute: typeof AuthenticatedOrgOrgIdProjectsIdSecretsRoute
  AuthenticatedOrgOrgIdProjectsIdSettingsRoute: typeof AuthenticatedOrgOrgIdProjectsIdSettingsRoute
  AuthenticatedOrgOrgIdProjectsIdIndexRoute: typeof AuthenticatedOrgOrgIdProjectsIdIndexRoute
}

const AuthenticatedOrgOrgIdRouteChildren: AuthenticatedOrgOrgIdRouteChildren = {
  AuthenticatedOrgOrgIdAccessRoute: AuthenticatedOrgOrgIdAccessRoute,
  AuthenticatedOrgOrgIdAlertsRoute: AuthenticatedOrgOrgIdAlertsRoute,
  AuthenticatedOrgOrgIdAuditRoute: AuthenticatedOrgOrgIdAuditRoute,
  AuthenticatedOrgOrgIdBackupsRoute: AuthenticatedOrgOrgIdBackupsRoute,
  AuthenticatedOrgOrgIdEnvironmentsRoute:
    AuthenticatedOrgOrgIdEnvironmentsRoute,
  AuthenticatedOrgOrgIdIntegrationsRoute:
    AuthenticatedOrgOrgIdIntegrationsRoute,
  AuthenticatedOrgOrgIdPlansRoute: AuthenticatedOrgOrgIdPlansRoute,
  AuthenticatedOrgOrgIdSecretsRoute: AuthenticatedOrgOrgIdSecretsRoute,
  AuthenticatedOrgOrgIdSettingsRoute: AuthenticatedOrgOrgIdSettingsRoute,
  AuthenticatedOrgOrgIdTestProjectRoute: AuthenticatedOrgOrgIdTestProjectRoute,
  AuthenticatedOrgOrgIdWebhooksRoute: AuthenticatedOrgOrgIdWebhooksRoute,
  AuthenticatedOrgOrgIdIndexRoute: AuthenticatedOrgOrgIdIndexRoute,
  AuthenticatedOrgOrgIdProjectsIndexRoute:
    AuthenticatedOrgOrgIdProjectsIndexRoute,
  AuthenticatedOrgOrgIdProjectsIdEnvironmentsRoute:
    AuthenticatedOrgOrgIdProjectsIdEnvironmentsRoute,
  AuthenticatedOrgOrgIdProjectsIdRuntimeConfigRoute:
    AuthenticatedOrgOrgIdProjectsIdRuntimeConfigRoute,
  AuthenticatedOrgOrgIdProjectsIdSecretsRoute:
    AuthenticatedOrgOrgIdProjectsIdSecretsRoute,
  AuthenticatedOrgOrgIdProjectsIdSettingsRoute:
    AuthenticatedOrgOrgIdProjectsIdSettingsRoute,
  AuthenticatedOrgOrgIdProjectsIdIndexRoute:
    AuthenticatedOrgOrgIdProjectsIdIndexRoute,
}

const AuthenticatedOrgOrgIdRouteWithChildren =
  AuthenticatedOrgOrgIdRoute._addFileChildren(
    AuthenticatedOrgOrgIdRouteChildren,
  )

interface AuthenticatedRouteChildren {
  AuthenticatedCreateOrganizationRoute: typeof AuthenticatedCreateOrganizationRoute
  AuthenticatedDashboardRoute: typeof AuthenticatedDashboardRouteWithChildren
  AuthenticatedOnboardingRoute: typeof AuthenticatedOnboardingRoute
  AuthenticatedOrgOrgIdRoute: typeof AuthenticatedOrgOrgIdRouteWithChildren
  AuthenticatedOrgEnvironmentsRoute: typeof AuthenticatedOrgEnvironmentsRoute
  AuthenticatedSettingsAccountRoute: typeof AuthenticatedSettingsAccountRoute
  AuthenticatedSettingsApiTokensRoute: typeof AuthenticatedSettingsApiTokensRoute
  AuthenticatedSettingsIndexRoute: typeof AuthenticatedSettingsIndexRoute
}

const AuthenticatedRouteChildren: AuthenticatedRouteChildren = {
  AuthenticatedCreateOrganizationRoute: AuthenticatedCreateOrganizationRoute,
  AuthenticatedDashboardRoute: AuthenticatedDashboardRouteWithChildren,
  AuthenticatedOnboardingRoute: AuthenticatedOnboardingRoute,
  AuthenticatedOrgOrgIdRoute: AuthenticatedOrgOrgIdRouteWithChildren,
  AuthenticatedOrgEnvironmentsRoute: AuthenticatedOrgEnvironmentsRoute,
  AuthenticatedSettingsAccountRoute: AuthenticatedSettingsAccountRoute,
  AuthenticatedSettingsApiTokensRoute: AuthenticatedSettingsApiTokensRoute,
  AuthenticatedSettingsIndexRoute: AuthenticatedSettingsIndexRoute,
}

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(
  AuthenticatedRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthenticatedRoute: AuthenticatedRouteWithChildren,
  InviteTokenRoute: InviteTokenRoute,
  OrgOrgIdIndexRoute: OrgOrgIdIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
